import debug from 'debug';
import plugin from '../../lib/vanilla-plugin';
import FetchInPlace from './fetch-in-place';

const MODULE_NAME = 'fetchInPlace';
const log = debug(MODULE_NAME);
const ELEMENT_SELECTOR = '[data-fetch-in-place]';

export function exec() {
	const elements = document.querySelectorAll(ELEMENT_SELECTOR);
	log('exec', elements);

	if (!elements) return false;

	plugin(MODULE_NAME, FetchInPlace)();
}



// WEBPACK FOOTER //
// ./client/src/core/modules/fetch-in-place/index.js